import React from 'react'
import { Alert, Col, Container, Row } from 'react-bootstrap'

interface ErrorViewProps {
  message: string
}

export const ErrorView = (props: ErrorViewProps) => {
  const { message } = props

  return (
    <Alert variant="danger">
      <Container>
        <Row>
          <Col>An Error has occurred</Col>
        </Row>
        <Row>
          <Col>{message}</Col>
        </Row>
      </Container>
    </Alert>
  )
}
